// @flow
import { handleActions } from 'redux-actions';
import { identity } from 'lodash/fp';

import handleReduce from '~/core/state/handle-reduce';

import { BRIDGE_NODE_CREATED, SEARCH_FOR_BRIDGE } from './constants';
import type { StateType } from './types';

const initialState: StateType = {
    error: null
};

export default handleActions(
    {
        [BRIDGE_NODE_CREATED]: handleReduce(identity, (_, { payload }) => ({ error: payload })),
        [SEARCH_FOR_BRIDGE]: handleReduce(() => ({ error: null }))
    },
    initialState
);



// WEBPACK FOOTER //
// ./src/core/state/install-hue-bridge/index.js